import {
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    YAxis,
} from "recharts";

interface TrendChartProps {
    trend?: number[];
}

const TrendChart: React.FC<TrendChartProps> = ({ trend = [] }) => {
    const chartData = trend.map((value, index) => ({
        index,
        value: Number(value),
    }));

    const values = chartData.map((item) => item.value);

    const minValue = values.length ? Math.min(...values) : 0;
    const maxValue = values.length ? Math.max(...values) : 1;

    // Add some padding so the line doesn't touch the edges
    const range = maxValue - minValue || 1;
    const padding = range * 0.15;

    const yMin = minValue - padding;
    const yMax = maxValue + padding;

    const CustomTooltip = ({ active, payload }: any) => {
        if (!active || !payload?.length) {
            return null;
        }

        return (
            <div
                style={{
                    padding: "6px 10px",
                    background: "white",
                    color: "var(--primary-color)",
                    borderRadius: 6,
                    boxShadow:'0px 0px 3px #ccc',
                    fontSize: 12,
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                }}
            >
                {payload[0].value}
            </div>
        );
    };

    if (!chartData.length) {
        return null;
    }

    return (
        <div
            style={{
                width: "100%",
                height: 40,
                maxHeight: 40,
                overflow: "visible",
            }}
        >
            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    data={chartData}
                    margin={{
                        top: 5,
                        right: 5,
                        bottom: 5,
                        left: 5,
                    }}
                >
                    <YAxis
                        hide
                        domain={[yMin, yMax]}
                    />

                    <Line
                        type="monotone"
                        dataKey="value"
                        stroke="var(--secondary-color)"
                        strokeWidth={2}
                        dot={{
                            r: 2.5,
                            strokeWidth: 0,
                            fill: "var(--secondary-color)",
                        }}
                        activeDot={{
                            r: 5,
                        }}
                        isAnimationActive={false}
                    />

                    <Tooltip
                        content={<CustomTooltip />}
                        cursor={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default TrendChart;

